'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/PolaroidPhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const PolaroidPhotoSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const PolaroidPhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={PolaroidPhotoSkin} />
);

export default PolaroidPhoto;
